import React from 'react';
import { Link } from 'react-router-dom';

const DEFAULT_GRADS = [
  'linear-gradient(135deg,#ecf6e3,#a4d977)',
  'linear-gradient(135deg,#a4d977,#50b848)',
  'linear-gradient(135deg,#ecf6e3,#72bf44)',
  'linear-gradient(135deg,#d7eecb,#50b848)',
  'linear-gradient(135deg,#eaf6df,#2e9d63)'
];

export default function NewsCard({ item, index = 0 }) {
  const bg = item.cover_gradient || DEFAULT_GRADS[index % DEFAULT_GRADS.length];
  const dateStr = item.published_date
    ? new Date(item.published_date).toLocaleDateString('vi-VN')
    : '';

  return (
    <article className="news-card">
      <div
        className="cover"
        style={{
          background: item.cover_url ? `url(${item.cover_url}) center/cover no-repeat` : bg
        }}
      />
      <div className="body">
        <span className="cat">{item.category || 'Tin tức'}</span>
        <h3>
          <Link to={`/tin-tuc/${item.key}`}>{item.title}</Link>
        </h3>
        <p>{item.lead}</p>
        <div className="meta">
          {dateStr && <span>{dateStr} · </span>}
          <span>{item.read_minutes || 3} phút đọc</span>
        </div>
      </div>
    </article>
  );
}
